// extracted by mini-css-extract-plugin
export default {"aboutMain":"AboutMain_aboutMain__AZwVy"};